(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/core')) :
    typeof define === 'function' && define.amd ? define('@shraddhar/web/typography', ['exports', '@angular/core'], factory) :
    (global = global || self, factory((global.shraddhar = global.shraddhar || {}, global.shraddhar.web = global.shraddhar.web || {}, global.shraddhar.web.typography = {}), global.ng.core));
}(this, (function (exports, core) { 'use strict';

    var MdcTypography = /** @class */ (function () {
        function MdcTypography() {
        }
        MdcTypography.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdc-typography], [mdcTypography]',
                        host: { 'class': 'mdc-typography' }
                    },] }
        ];
        return MdcTypography;
    }());
    var MdcHeadline1 = /** @class */ (function () {
        function MdcHeadline1() {
        }
        MdcHeadline1.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcHeadline1]',
                        host: { 'class': 'mdc-typography--headline1' }
                    },] }
        ];
        return MdcHeadline1;
    }());
    var MdcHeadline2 = /** @class */ (function () {
        function MdcHeadline2() {
        }
        MdcHeadline2.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcHeadline2]',
                        host: { 'class': 'mdc-typography--headline2' }
                    },] }
        ];
        return MdcHeadline2;
    }());
    var MdcHeadline3 = /** @class */ (function () {
        function MdcHeadline3() {
        }
        MdcHeadline3.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcHeadline3]',
                        host: { 'class': 'mdc-typography--headline3' }
                    },] }
        ];
        return MdcHeadline3;
    }());
    var MdcHeadline4 = /** @class */ (function () {
        function MdcHeadline4() {
        }
        MdcHeadline4.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcHeadline4]',
                        host: { 'class': 'mdc-typography--headline4' }
                    },] }
        ];
        return MdcHeadline4;
    }());
    var MdcHeadline5 = /** @class */ (function () {
        function MdcHeadline5() {
        }
        MdcHeadline5.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcHeadline5]',
                        host: { 'class': 'mdc-typography--headline5' }
                    },] }
        ];
        return MdcHeadline5;
    }());
    var MdcHeadline6 = /** @class */ (function () {
        function MdcHeadline6() {
        }
        MdcHeadline6.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcHeadline6]',
                        host: { 'class': 'mdc-typography--headline6' }
                    },] }
        ];
        return MdcHeadline6;
    }());
    var MdcSubtitle1 = /** @class */ (function () {
        function MdcSubtitle1() {
        }
        MdcSubtitle1.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcSubtitle1]',
                        host: { 'class': 'mdc-typography--subtitle1' }
                    },] }
        ];
        return MdcSubtitle1;
    }());
    var MdcSubtitle2 = /** @class */ (function () {
        function MdcSubtitle2() {
        }
        MdcSubtitle2.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcSubtitle2]',
                        host: { 'class': 'mdc-typography--subtitle2' }
                    },] }
        ];
        return MdcSubtitle2;
    }());
    var MdcBody2 = /** @class */ (function () {
        function MdcBody2() {
        }
        MdcBody2.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcBody2]',
                        host: { 'class': 'mdc-typography--body2' }
                    },] }
        ];
        return MdcBody2;
    }());
    var MdcBody1 = /** @class */ (function () {
        function MdcBody1() {
        }
        MdcBody1.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcBody1]',
                        host: { 'class': 'mdc-typography--body1' }
                    },] }
        ];
        return MdcBody1;
    }());
    var MdcCaption = /** @class */ (function () {
        function MdcCaption() {
        }
        MdcCaption.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcCaption]',
                        host: { 'class': 'mdc-typography--caption' }
                    },] }
        ];
        return MdcCaption;
    }());
    var MdcTypographyButton = /** @class */ (function () {
        function MdcTypographyButton() {
        }
        MdcTypographyButton.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcButton]',
                        host: { 'class': 'mdc-typography--button' }
                    },] }
        ];
        return MdcTypographyButton;
    }());
    var MdcOverline = /** @class */ (function () {
        function MdcOverline() {
        }
        MdcOverline.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcOverline]',
                        host: { 'class': 'mdc-typography--overline' }
                    },] }
        ];
        return MdcOverline;
    }());

    var TYPOGRAPHY_DECLARATIONS = [
        MdcTypography,
        MdcBody1,
        MdcBody2,
        MdcTypographyButton,
        MdcCaption,
        MdcHeadline1,
        MdcHeadline2,
        MdcHeadline3,
        MdcHeadline4,
        MdcHeadline5,
        MdcHeadline6,
        MdcOverline,
        MdcSubtitle1,
        MdcSubtitle2
    ];
    var MdcTypographyModule = /** @class */ (function () {
        function MdcTypographyModule() {
        }
        MdcTypographyModule.decorators = [
            { type: core.NgModule, args: [{
                        exports: TYPOGRAPHY_DECLARATIONS,
                        declarations: TYPOGRAPHY_DECLARATIONS
                    },] }
        ];
        return MdcTypographyModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    exports.MdcBody1 = MdcBody1;
    exports.MdcBody2 = MdcBody2;
    exports.MdcCaption = MdcCaption;
    exports.MdcHeadline1 = MdcHeadline1;
    exports.MdcHeadline2 = MdcHeadline2;
    exports.MdcHeadline3 = MdcHeadline3;
    exports.MdcHeadline4 = MdcHeadline4;
    exports.MdcHeadline5 = MdcHeadline5;
    exports.MdcHeadline6 = MdcHeadline6;
    exports.MdcOverline = MdcOverline;
    exports.MdcSubtitle1 = MdcSubtitle1;
    exports.MdcSubtitle2 = MdcSubtitle2;
    exports.MdcTypography = MdcTypography;
    exports.MdcTypographyButton = MdcTypographyButton;
    exports.MdcTypographyModule = MdcTypographyModule;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=web-typography.umd.js.map
